export default "__VITE_ASSET__DywGMUkx__"